import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const CustomModalLarge = ({ isVisible, onClose, children }) => {

    useEffect(() => {
        // Funkcia na zatvorenie modalu pri stlačení klávesy ESC
        const handleEscKey = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        // Pridanie event listeneru
        document.addEventListener('keydown', handleEscKey);

        // Odstránenie event listeneru pri unmount
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [onClose]);
    
    return ReactDOM.createPortal(
        <>
            {/* Overlay */}
            <div 
                className={`custom-modal-overlay ${isVisible ? 'visible' : ''}`} 
                onClick={onClose}
            ></div>
            
            {/* Modal */}
            <div className={`custom-modal-large ${isVisible ? 'visible' : ''}`}>
                <div className="custom-modal-large-content">
                    <button className="close-button" onClick={onClose}>×</button>
                    {children}
                </div>
            </div>
        </>,
        document.body // Modal sa umiestni priamo do koreňa dokumentu
    );
};

export default CustomModalLarge;
